import { CounterpartyPermissionLevel } from '../gql/graphql';

/**
 * Re-export the codegen-generated enum for use throughout the app.
 * This ensures type compatibility with GraphQL mutations.
 */
export { CounterpartyPermissionLevel };

/**
 * Human-readable labels for each permission level.
 * Used in dropdown menus and UI displays.
 */
export const COUNTERPARTY_PERMISSION_LABELS: Record<CounterpartyPermissionLevel, string> = {
  [CounterpartyPermissionLevel.CommentOnly]: 'Comment Only',
  [CounterpartyPermissionLevel.FormFilling]: 'Comment and Form Filling',
  [CounterpartyPermissionLevel.FullEditing]: 'Comment, Form Filling and Page Editing',
};

/**
 * Convert legacy boolean flags to new permission level.
 * Used for backward compatibility during migration.
 */
export function booleansToPermissionLevel(
  receiverCollaborationEnabled: boolean,
  receiverPagePdfEditingEnabled: boolean
): CounterpartyPermissionLevel {
  if (receiverPagePdfEditingEnabled) {
    return CounterpartyPermissionLevel.FullEditing;
  }
  if (receiverCollaborationEnabled) {
    return CounterpartyPermissionLevel.FormFilling;
  }
  return CounterpartyPermissionLevel.CommentOnly;
}

/**
 * Convert permission level to legacy boolean flags.
 * Used for backward compatibility with legacy API calls.
 */
export function permissionLevelToBooleans(level: CounterpartyPermissionLevel): {
  receiverCollaborationEnabled: boolean;
  receiverPagePdfEditingEnabled: boolean;
} {
  switch (level) {
    case CounterpartyPermissionLevel.FullEditing:
      return { receiverCollaborationEnabled: true, receiverPagePdfEditingEnabled: true };
    case CounterpartyPermissionLevel.FormFilling:
      return { receiverCollaborationEnabled: true, receiverPagePdfEditingEnabled: false };
    case CounterpartyPermissionLevel.CommentOnly:
    default:
      return { receiverCollaborationEnabled: false, receiverPagePdfEditingEnabled: false };
  }
}

/**
 * Check if a permission level allows form filling.
 */
export function canFillForms(level: CounterpartyPermissionLevel): boolean {
  return level === CounterpartyPermissionLevel.FormFilling ||
         level === CounterpartyPermissionLevel.FullEditing;
}

/**
 * Check if a permission level allows page editing.
 */
export function canEditPages(level: CounterpartyPermissionLevel): boolean {
  return level === CounterpartyPermissionLevel.FullEditing;
}
